import script from "./ProyectosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProyectosView.vue?vue&type=script&setup=true&lang=js"

import "./ProyectosView.vue?vue&type=style&index=0&id=53033c46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53033c46"]])

export default __exports__